<section class="error">
  <div class="error__inner">
      <h1>403</h1>
      <h2>{{'error.label.403' | translate}}</h2>
      <!-- <p>{{'error.label.403.desc' | translate}}</p> -->
      <p>{{error}}</p>

      <button class="btn btn-primary" (click)="goBack()"> {{ 'generic.label.go.back' | translate}} </button>

  </div>
</section>
